/**
 * Prettier labels for the app source keys device-service reports. Purely cosmetic: any key
 * without an entry falls through to a readable form of the key itself, so an integration
 * seeded in device-service shows up here without a portal release.
 */
const APP_SOURCE_LABEL_OVERRIDES: Record<string, string> = {
  INTUNE: 'Intune',
  WORKSPACE_ONE_UEM: 'Workspace ONE',
  QSCOUT_PDM: 'Q-scout PDM',
  API: 'API',
};

/** 'BULK_SUBMIT' -> 'Bulk Submit' */
const titleCaseKey = (appSource: string): string =>
  appSource
    .split('_')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export function formatAppSourceDisplay(appSource: string | undefined | null): string {
  if (!appSource) {
    return 'Unknown';
  }

  return APP_SOURCE_LABEL_OVERRIDES[appSource] ?? titleCaseKey(appSource);
}
